import { SpinnerService } from '../../../services/spinner.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Cliente } from '../../../models/cliente.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteFormService } from '../../../services/cliente-form.service';
import { ClienteSubmissionService } from '../../../services/cliente-submission.service';
import { LocationService } from '../../../services/location-service.service';
import { CountryService } from '../../../services/country-service.service';
import { tipoLogradouros } from '../../../helpers/logradouro.helper';
import { FormatadorHelper } from '../../../helpers/formatador.helper';
import {
  descricaoIdentificacaoCpfCnpj,
  IdentificacaoCpfCnpj,
} from '../../../models/enums/identificacao-cpf-cnpj.enum';
import { ClienteService } from '../../../services/clientes.service';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { MapeamentoHelper } from '../../../helpers/mapeamentoObjeto.helper';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { Validators } from '@angular/forms';


@Component({
  selector: 'app-clientes-editar',
  templateUrl: './clientes-editar.component.html',
  styleUrls: ['./clientes-editar.component.scss'],
})
export class ClientesEditarComponent implements OnInit {
  @Output() editComplete = new EventEmitter<{ cliente: Cliente }>();
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  clienteForm: FormGroup;
  identificacaoCpfCnpj: string = '';
  readonly IdentificacaoCpfCnpjEnum = IdentificacaoCpfCnpj;
  readonly exemploCnpj = FormatadorHelper.EXEMPLO_CNPJ;
  identificacoesCpfCnpjs: any[] = [
    { nome: 'CPF', tipo: IdentificacaoCpfCnpj.Cpf },
    { nome: 'CNPJ', tipo: IdentificacaoCpfCnpj.Cnpj },
    { nome: 'Exterior', tipo: 'Exterior' }
  ];
  clienteId: number | null = null;
  estados: { label: string; value: string }[] = [];
  municipios: { label: string; value: string }[] = [];
  municipiosLoaded: { label: string; value: string }[] = [];
  paises: { label: string; value: string }[] = [];
  tipoLogradouros = tipoLogradouros;
  maxCpfCnpjLength: number = 14;
  loading: boolean = false;
  isReadonly: boolean = false;
  cpfCnpjEnabled: boolean = false;
  cpfCnpjLabel: string = 'CPF/CNPJ';
  ufEnabled: boolean = true;
  municipioEnabled: boolean = true;


  constructor(
    private clienteService: ClienteService,
    private clienteFormService: ClienteFormService,
    private clienteSubmissionService: ClienteSubmissionService,
    private router: Router,
    private locationService: LocationService,
    private countryService: CountryService,
    private route: ActivatedRoute,
    private jwtHelper: JwtHelper,
    public spinnerService: SpinnerService
  ) {
    this.clienteForm = this.clienteFormService.createForm();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Editar Cliente');
    this.iconeChange.emit('pi pi-user-plus');
    this.InicializarDadosIBGE();

    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.clienteId = +id;
        this.spinnerService.show('Carregando dados do cliente...');
        this.loadCliente();
      }
    });
  }

  InicializarDadosIBGE() {
    this.paises = this.countryService.getCountries();

    this.spinnerService.show('Carregando estados...');
    this.locationService
      .getEstados()
      .pipe()
      .subscribe((estados) => {
        this.estados = estados
          .map((estado: any) => ({
            label: estado.sigla,
            value: estado.sigla,
            id: estado.id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
      });

    this.clienteForm.get('uf')?.valueChanges.subscribe((ufSigla) => {
      const estado = this.estados.find((e) => e.value === ufSigla);
      if (estado) {
        this.spinnerService.show('Carregando municípios...');
        this.locationService
          .getMunicipiosPorUf(estado.value)
          .pipe()
          .subscribe((municipios) => {
            this.municipios = municipios
              .map((municipio: any) => ({
                label: municipio.nome,
                value: municipio.id,
              }))
              .sort((a, b) => a.label.localeCompare(b.label));

            this.clienteForm.get('municipio')?.setValue(null);
            this.clienteForm.get('codigoMunicipio')?.setValue(null);
          });
      }
    });

    this.clienteForm.get('municipio')?.valueChanges.subscribe((municipioId) => {

      const municipio = this.municipios.find((m) => m.value === municipioId);

      if (municipio) {
        this.clienteForm.get('codigoMunicipio')?.setValue(municipio.value);

      } else {
        this.clienteForm.get('codigoMunicipio')?.setValue(null);
      }
    });

  }

  loadCliente() {
    if (this.clienteId) {
      this.clienteService
        .getClienteById(this.clienteId)
        .pipe(
          catchError((error) => {
            console.error('Erro ao carregar o cliente:', error);
            return of(null);
          }),
          finalize(() => this.spinnerService.hide())
        )
        .subscribe((cliente) => {
          if (cliente) {
            this.clienteForm.patchValue(cliente);
            const tipoIdentificacao = this.defineCpfCnpj(cliente.cpfCnpj, true);
            this.clienteForm
              .get('tipoIdentificacaoCpfCnpj')
              .setValue(tipoIdentificacao);
            this.onChangeidentificacaoCpfCnpj(tipoIdentificacao);

            this.AtualizarDadosIBGE(cliente);
            this.setMunicipio(cliente.codigoMunicipio);

            const pais = cliente.pais;
            this.onChangePais(pais);
          }
        });
    }
  }

  AtualizarDadosIBGE(cliente: Cliente) {
    if (cliente.uf) {
      this.onUfChange(cliente.uf).subscribe(() => {
        this.setMunicipio(cliente.codigoMunicipio);
      });
    }
  }

  onUfChange(uf: string): Observable<any> {
    if (uf) {
      this.spinnerService.show('Carregando municípios...');
      return this.locationService.getMunicipiosPorUf(uf).pipe(
        catchError((error) => {
          console.error('Erro ao carregar os municípios:', error);
          return of([]);
        }),
        finalize(() => this.spinnerService.hide()),
        tap((municipios) => {
          this.municipios = municipios.map((municipio: any) => ({
            label: municipio.nome,
            value: municipio.id,
          }));
          this.municipiosLoaded = [...this.municipios];
        })
      );
    } else {
      this.municipios = [];
      this.clienteForm.get('municipio')?.setValue(null);
      return of([]);
    }
  }

  setMunicipio(codigoMunicipio: string | null) {
    if (codigoMunicipio) {
      const checkMunicipio = () => {
        const selectedMunicipio = this.municipios.find(
          (municipio) => municipio.value === codigoMunicipio
        );

        if (selectedMunicipio) {
          this.clienteForm.get('municipio')?.setValue(selectedMunicipio.value);
          this.clienteForm.get('codigoMunicipio')?.setValue(selectedMunicipio.value);
        } else {
          this.locationService.getMunicipiosPorMunicipioId(codigoMunicipio).subscribe((municipio: any) => {
            if (municipio) {
              const mappedMunicipio = {
                label: municipio.nome,
                value: municipio.id,
              };
              this.municipios.push(mappedMunicipio);
              this.clienteForm.get('municipio')?.setValue(mappedMunicipio.value);
              this.clienteForm.get('codigoMunicipio')?.setValue(mappedMunicipio.value);
            } else {
              this.clienteForm.get('municipio')?.setValue(null);
              this.clienteForm.get('codigoMunicipio')?.setValue(null);
            }
          });
        }
      };

      if (this.municipios.length > 0) {
        checkMunicipio();
      } else {
        setTimeout(() => checkMunicipio(), 500);
      }
    } else {
      this.clienteForm.get('municipio')?.setValue(null);
      this.clienteForm.get('codigoMunicipio')?.setValue(null);
    }
  }


  removeDuplicateMunicipios(
    municipios: { label: string; value: string }[]
  ): { label: string; value: string }[] {
    const uniqueValues = new Set<string>();
    return municipios.filter((municipio) => {
      if (uniqueValues.has(municipio.value)) {
        return false;
      } else {
        uniqueValues.add(municipio.value);
        return true;
      }
    });
  }

  onSubmit() {
    if (this.clienteForm.valid && this.clienteId !== null) {
      const municipioId = this.clienteForm.get('municipio')?.value;
      if (municipioId) {
        this.clienteForm
          .get('codigoMunicipio')
          ?.setValue(municipioId);
      }
      
      const apelidoValue = this.clienteForm.get('apelido')?.value || '';
      this.clienteForm.get('razaoSocial')?.setValue(apelidoValue);
      this.clienteForm.get('nomeRazaoSocial')?.setValue(apelidoValue);

      this.spinnerService.show('Salvando alterações...');
      this.clienteForm
        .get('usuarioId')
        .setValue(this.jwtHelper.getUserIdFromToken());

      const complementoValue = this.clienteForm.get('complemento')?.value;
      if (!complementoValue || complementoValue.trim() === '') {
        this.clienteForm.get('complemento')?.setValue('-');
      }

      const cliente = MapeamentoHelper.mapeaFormParaCliente(
        this.clienteForm.value
      );
      cliente.id = this.clienteId;
      this.clienteSubmissionService
        .editCliente(this.clienteId, cliente)
        .pipe(
          finalize(() => {
            this.spinnerService.hide();
          })
        )
        .subscribe({
          next: (cliente) => {
            this.editComplete.emit({ cliente: cliente });
          },
          error: (error) => {
            console.error('Erro ao editar o cliente:', error);
          },
        });
    }
  }

  onCancel() {
    this.router.navigate(['/clientes']);
  }

  onChangeidentificacaoCpfCnpj(value: string) {
    this.identificacaoCpfCnpj = value;

    if (value === IdentificacaoCpfCnpj.Cpf) {
      this.cpfCnpjLabel = 'CPF';
      this.maxCpfCnpjLength = 14;
      this.cpfCnpjEnabled = true;
      this.clienteForm.get('cpfCnpj')?.enable();
      this.clienteForm.get('cpfCnpj')?.setValidators([
        Validators.required,
        Validators.minLength(14),
        Validators.maxLength(14),
      ]);
    } else if (value === IdentificacaoCpfCnpj.Cnpj) {
      this.cpfCnpjLabel = 'CNPJ';
      this.maxCpfCnpjLength = 18;
      this.cpfCnpjEnabled = true;
      this.clienteForm.get('cpfCnpj')?.enable();
      this.clienteForm.get('cpfCnpj')?.setValidators([
        Validators.required,
        Validators.minLength(18),
        Validators.maxLength(18),
      ]);
    } else {
      this.cpfCnpjLabel = 'Número do Documento';
      this.cpfCnpjEnabled = false;
      this.clienteForm.get('cpfCnpj')?.disable();
      this.clienteForm.get('cpfCnpj')?.clearValidators();
    }

    this.clienteForm.get('cpfCnpj')?.updateValueAndValidity();

    const formattedValue = FormatadorHelper.formatarCpfCnpj(
      this.clienteForm.get('cpfCnpj')?.value || ''
    );
    this.clienteForm.get('cpfCnpj')?.setValue(formattedValue);
  }


  onCpfCnpjInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const isCpf = this.identificacaoCpfCnpj === IdentificacaoCpfCnpj.Cpf;
    this.clienteForm.get('cpfCnpj')?.setValue(
      FormatadorHelper.aplicarMascaraDuranteInput(input.value, isCpf),
      { emitEvent: false }
    );
  }

  defineCpfCnpj(cpfCnpj: string | null, retornarEnum: boolean = false): string {
    if (!cpfCnpj) {
      return '';
    }

    const documentoNormalizado = FormatadorHelper.normalizarDocumento(cpfCnpj);

    if (FormatadorHelper.ehCpf(documentoNormalizado)) {
      return retornarEnum
        ? IdentificacaoCpfCnpj.Cpf
        : descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cpf];
    }

    if (FormatadorHelper.ehCnpj(documentoNormalizado)) {
      return retornarEnum
        ? IdentificacaoCpfCnpj.Cnpj
        : descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cnpj];
    }

    return '';
  }

  onMunicipioDropdownClick() {
    this.refreshMunicipiosList();
  }

  refreshMunicipiosList() {
    const uf = this.clienteForm.get('uf')?.value;

    if (uf) {
      this.loading = true;
      this.locationService
        .getMunicipiosPorUf(uf)
        .pipe(
          catchError((error) => {
            console.error('Erro ao carregar os municípios:', error);
            return of([]);
          }),
          finalize(() => (this.loading = false))
        )
        .subscribe((municipios) => {
          const uniqueMunicipiosMap = new Map<
            string,
            { label: string; value: string }
          >();

          municipios.forEach((municipioObj: any) => {
            const nome = municipioObj.municipio.nome;
            if (!uniqueMunicipiosMap.has(nome)) {
              uniqueMunicipiosMap.set(nome, {
                label: nome,
                value: municipioObj.municipio.id,
              });
            }
          });

          this.municipios = Array.from(uniqueMunicipiosMap.values());
        });
    }
  }

  getMask(): string {
    return this.identificacaoCpfCnpj === IdentificacaoCpfCnpj.Cpf
      ? FormatadorHelper.MASCARA_CPF
      : this.identificacaoCpfCnpj === IdentificacaoCpfCnpj.Cnpj
      ? FormatadorHelper.MASCARA_CNPJ
      : '';
  }

  onChangePais(selectedPais: string) {
    const isBrasil = selectedPais === 'BR';

    this.ufEnabled = isBrasil;
    this.municipioEnabled = isBrasil;

    if (!isBrasil) {
      this.clienteForm.get('uf')?.setValue('');
      this.clienteForm.get('municipio')?.setValue('');
      this.clienteForm.get('codigoMunicipio')?.setValue('');
    }

    if (isBrasil) {
      this.clienteForm.get('codigoMunicipio')?.clearValidators();
    } else {
      this.clienteForm.get('uf')?.clearValidators();
      this.clienteForm.get('codigoMunicipio')?.clearValidators();
    }

    this.clienteForm.get('uf')?.updateValueAndValidity();
    this.clienteForm.get('codigoMunicipio')?.updateValueAndValidity();
  }

}


